import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import GoogleAnalyticsEventAction from "enums/googleAnalyticsEventAction";
import GoogleAnalyticsEventCategory from "enums/googleAnalyticsEventCategory";

/* Creates a new instance of a Google Analytics Tdv metric Mixin to track users events when the user subimits a lead. */
export default class EventTrackingTdvMetricsMixin {
    constructor(model) {
      Object.assign(this, model);
    }
  
    getGoogleAnalyticsData() {    
      const eventLabel =  `MN: ${this.marketName} | BN: ${this.builderName} | CN: ${this.communityName} | CI: ${this.communityId}`;
      return new GoogleAnalyticsEvent(
        GoogleAnalyticsEventCategory.TdvMetrics.toString(),
        GoogleAnalyticsEventAction.Leads.toString(),
        eventLabel);
    }
  }